import React from "react";

const Content: React.FC = ({ children }) => (
  <div className="content" style={{ position: "relative", padding: "50px" }}>
    {children}
  </div>
);

export default Content;
